// eslint-disable-next-line
/// <reference path="../pug.d.ts" />
// @ts-check
'use strict';

/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const convertCodeToText = (node) => {
  // NOTE: 予期せぬ挙動を防ぐために pug の Interpolation を削除
  // NOTE: https://pugjs.org/language/interpolation.html
  if (node.type !== 'Code') {
    return node;
  }

  return {
    type: 'Text',
    val: '',
    line: node.line,
  };
};

module.exports = { convertCodeToText };
